<div>
  <app-page-header pageTitle="{{ 'Dashboard.Navigation.Departments' | translate }}">
    <div>
      <div class="d-inline-block">
        <mat-form-field>
          <input matInput (keyup)="filterDepartments($event.target.value)"
                 placeholder="{{ 'Common.Filter' | translate }}">
        </mat-form-field>
      </div>

      <button class="ml-5"
              mat-raised-button color="primary"
              (click)="addNewDepartmentAsync()">
        <fa-icon icon="plus" class="mr-1"></fa-icon>

        {{ 'Dashboard.Departments.AddNewDepartment' | translate }}
      </button>
    </div>
  </app-page-header>

  <div class="w-100">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z4 w-100">
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Common.Name' | translate }}</th>
        <td mat-cell *matCellDef="let department">
          <div *ngIf="!department.isEditing">{{ department.value.name }}</div>

          <div *ngIf="department.isEditing">
            <mat-form-field>
              <input matInput placeholder="{{ 'Common.Name' | translate }}" [(ngModel)]="department.value.name"
                     required>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{ 'Common.Actions' | translate }}</th>
        <td mat-cell *matCellDef="let department">
          <button mat-raised-button color="primary" class="mr-2"
                  [attr.title]="'Common.Edit' | translate"
                  *ngIf="!department.isEditing"
                  (click)="startEditingDepartmentAsync(department)">
            <fa-icon icon="pencil-alt"></fa-icon>
          </button>

          <button mat-raised-button class="mr-2"
                  *ngIf="department.isEditing"
                  (click)="cancelEditingDepartmentAsync(department)">
            {{ 'Common.Cancel' | translate }}
          </button>

          <app-button [loading]="updateDepartmentInProgress" color="primary" class="mr-2"
                      *ngIf="department.isEditing"
                      (click)="editDepartmentAsync(department)">
            {{ 'Common.Save' | translate }}
          </app-button>

          <button mat-raised-button color="warn"
                  [attr.title]="'Common.Remove' | translate"
                  (click)="removeDepartmentAsync(department)">
            <fa-icon icon="trash"></fa-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div class="text-center mt-3" *ngIf="isLoading">
      <app-loading-indicator></app-loading-indicator>
    </div>
  </div>
</div>